"use strict";
/*
This page includes frequently used typed - particularly helpful for State and Api where we can strongly type stuff
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_MODULES = exports.ALL_TOOL_PANELS = exports.ALL_STATUS_SUB_PANELS = exports.ALL_TOOLBARS = void 0;
const tslib_1 = require("tslib");
const ModuleConstants = tslib_1.__importStar(require("../../Utilities/Constants/ModuleConstants"));
exports.ALL_TOOLBARS = [
    'Alert',
    'BulkUpdate',
    'CellSummary',
    'Charting',
    'DataChangeHistory',
    'DataSet',
    'Export',
    'Glue42',
    'IPushPull',
    'Layout',
    'ColumnFilter',
    'GridFilter',
    'OpenFin',
    'QuickSearch',
    'SmartEdit',
    'StateManagement',
    'SystemStatus',
    'Theme',
];
exports.ALL_STATUS_SUB_PANELS = [
    'Alert',
    'BulkUpdate',
    'CalculatedColumn',
    'CellSummary',
    'CustomSort',
    'Charting',
    'Dashboard',
    'DataChangeHistory',
    'DataImport',
    'DataSet',
    'Export',
    'ColumnFilter',
    'GridFilter',
    'FlashingCell',
    'FormatColumn',
    'FreeTextColumn',
    'GridInfo',
    'Layout',
    'PlusMinus',
    'QuickSearch',
    'Schedule',
    'SettingsPanel',
    'Shortcut',
    'SmartEdit',
    'StateManagement',
    'StatusBar',
    'SystemStatus',
    'TeamSharing',
    'Theme',
    'ToolPanel',
];
exports.ALL_TOOL_PANELS = [
    'Alert',
    'BulkUpdate',
    'CellSummary',
    'Charting',
    'Dashboard',
    'DataChangeHistory',
    'Export',
    'ColumnFilter',
    'GridFilter',
    'IPushPull',
    'Layout',
    'OpenFin',
    'QuickSearch',
    'SmartEdit',
    'StateManagement',
    'SystemStatus',
    'Theme',
];
exports.ALL_MODULES = [
    ModuleConstants.AlertModuleId,
    ModuleConstants.BulkUpdateModuleId,
    ModuleConstants.CalculatedColumnModuleId,
    ModuleConstants.CellSummaryModuleId,
    ModuleConstants.NotesModuleId,
    ModuleConstants.ChartingModuleId,
    ModuleConstants.CustomSortModuleId,
    ModuleConstants.DashboardModuleId,
    ModuleConstants.DataChangeHistoryModuleId,
    ModuleConstants.DataSetModuleId,
    ModuleConstants.DataImportModuleId,
    ModuleConstants.ExportModuleId,
    ModuleConstants.FlashingCellModuleId,
    ModuleConstants.FormatColumnModuleId,
    ModuleConstants.FreeTextColumnModuleId,
    ModuleConstants.Glue42ModuleId,
    ModuleConstants.GridInfoModuleId,
    ModuleConstants.IPushPullModuleId,
    ModuleConstants.LayoutModuleId,
    ModuleConstants.OpenFinModuleId,
    ModuleConstants.PlusMinusModuleId,
    ModuleConstants.QuickSearchModuleId,
    ModuleConstants.ScheduleModuleId,
    ModuleConstants.SettingsPanelModuleId,
    ModuleConstants.ShortcutModuleId,
    ModuleConstants.SmartEditModuleId,
    ModuleConstants.StyledColumnModuleId,
    ModuleConstants.StateManagementModuleId,
    ModuleConstants.StatusBarModuleId,
    ModuleConstants.SystemStatusModuleId,
    ModuleConstants.TeamSharingModuleId,
    ModuleConstants.ThemeModuleId,
    ModuleConstants.ToolPanelModuleId,
    ModuleConstants.GridFilterModuleId,
    ModuleConstants.ColumnFilterModuleId,
    ModuleConstants.NamedQueryModuleId,
];
